
/* Hero */
// add on hero button click perform tab click and scroll to the tab section content
const heroButtons = document.querySelectorAll('.hero__button a.btn--small');
for (const heroButton of heroButtons) {
    // get and validate hreft contains # and get the tab id
    const href = heroButton.getAttribute('href');
    if (href) {
        const hasDataTabId = href.includes('#data-tab-');
        if (hasDataTabId) {
            const tab = document.querySelector(`${href}`);
            const tabWrapper = document.querySelector(`#tabs-wrapper`);
            heroButton.addEventListener('click', function (e) {
                e.preventDefault();
                tab.click();
                tabWrapper.scrollIntoView({ behavior: 'smooth' });
            });
        }
    }



    // heroButton.addEventListener('click', function () {
    //     const tabId = heroButton.getAttribute('data-tab-id');
    //     const tabContent = document.querySelector(`.hero__tab-content[data-tab-id="${tabId}"]`);
    //     const tab = document.querySelector(`.hero__tab[data-tab-id="${tabId}"]`);
    //     tab.click();
    //     tabContent.scrollIntoView({ behavior: 'smooth' });
    // });
}
/**
 * Footer
 */
// const accordionHeaders = document.querySelectorAll('.footer__block--content');

// for (const accordionHeader of accordionHeaders) {
//     const footerCollapse = accordionHeader.querySelector('.footer__block--collapse');
//     const footerCollapseHeight = footerCollapse.clientHeight;
//     footerCollapse.setAttribute('data-max-height', footerCollapseHeight);
//     if (window.innerWidth < 768) {
//         footerCollapse.style.height = 0;
//     }

//     accordionHeader.addEventListener('click', function () {
//         accordionHeader.classList.toggle('active');
//         //set height of footer__quicklinks element to 0 if it's not has the class active
//         if (!accordionHeader.classList.contains('active')) {
//             footerCollapse.style.height = 0;
//         } else {
//             const height = footerCollapse.getAttribute('data-max-height') * 1.0;
//             //set height of footer__quicklinks element to the value of data-max-height attribute
//             footerCollapse.style.height = (height + 10) + 'px';
//         }
//     });

// }

/**
 * Recharge Account page
 */
let rechargeButton = document.querySelector('#ShippingPage .add-shipping-info.rc-btn.rc-btn--primary');
if (rechargeButton) {
  rechargeButton.textContent = 'Add Shipping Address';  
}
// document.querySelector('#ShippingPage .add-shipping-info.rc-btn.rc-btn--primary').textContent = 'Add Shipping Address';
